import React, { useState, useRef, useEffect } from 'react';

function Dropdown({ category, label, value, onChange }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleDropdownClick = (item) => {
    if (onChange) {
      onChange(item); // Pass the selected item directly to the parent component
    }
    setDropdownOpen(false); // Close dropdown after selection
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false); // Close sidebar if click is outside
      }
    }

    // Add event listener for detecting clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Remove event listener on cleanup
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="text-black font-poppins bg-btn-color hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center "
        type="button"
      >
        {value ? value : label} {/* Show selected value or label */}
        <svg
          className="w-2.5 h-2.5 ms-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 1l4 4 4-4"
          />
        </svg>
      </button>

      {/* Dropdown menu */}
      {dropdownOpen && (
        <div
          ref={dropdownRef}
          className="absolute mt-2 z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
          role="menu"
        >
          <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
            {label === 'Select a collection'
              ? category.map((item, index) => (
                  <li key={index} role="menuitem">
                    <button
                      className="w-full text-left font-poppins block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => handleDropdownClick(item)}
                    >
                      {item.eventCollectionName}
                    </button>
                  </li>
                ))
              : category.map((item, index) => (
                  <li key={index} role="menuitem">
                    <button
                      className="w-full text-left font-poppins block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => handleDropdownClick(item)}
                    >
                      {item}
                    </button>
                  </li>
                ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Dropdown;
